import React from 'react';
import FontAwesome from 'react-fontawesome';

const Footer = () => (
    <div className='footer'>
        <div className='join'>
            <div className='container'>
                <h2 className='title'>Try us now and run your first payroll for FREE</h2>
                <p className='description'>No Obligations or Credit Card Details Required</p>
                <a className='button' href="https://app.payrollpanda.my/#signup?&utm_source=pcb-calculator&utm_medium=homepage">
                    Get started
                </a>
            </div>
        </div>

        <div className='copyright'>
            <div className='container'>
                <div className='row'>
                    <div className='col-12'>
                        <p>Copyright &copy; {new Date().getFullYear()} Payroll Panda Sdn Bhd. All Rights Reserved.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js